import { render, staticRenderFns } from "./certificadotitulo.vue?vue&type=template&id=42c67a9a&scoped=true"
import script from "./certificadotitulo.vue?vue&type=script&lang=js"
export * from "./certificadotitulo.vue?vue&type=script&lang=js"
import style0 from "./certificadotitulo.vue?vue&type=style&index=0&id=42c67a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c67a9a",
  null
  
)

export default component.exports